import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import './PageNotFoundDataRoom.styles.scss';

type PageNotFoundDataRoomProps = {
  className?: string;
};

const PageNotFoundDataRoom: React.FC<PageNotFoundDataRoomProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();

  const classes = classNames('page-not-found-data-room', className);

  return (
    <div className={classes}>
      <h1>{t('pageNotFound')}</h1>
      <p>{t('pnfDescriptionDataRoom')}</p>
    </div>
  );
};

export default PageNotFoundDataRoom;
